import * as React from 'react'
import { useShopify } from '../../../providers/ShopifyProvider'
import {
  ShopifyStorefrontProduct,
  ShopifyStorefrontProductVariant,
} from '../../../types'
import { Button } from '../../../components/Button'
import { BuyButtonWrapper } from './styles'

interface Props {
  product: ShopifyStorefrontProduct
  selectedVariant?: ShopifyStorefrontProductVariant
  quantity?: number
}

export const BuyButton = ({ selectedVariant, quantity }: Props) => {
  const { loading, addLineItem } = useShopify()

  const buttonLabel = 'Add to Bag'

  const handleClick = async () => {
    if (!selectedVariant) return
    await addLineItem({
      variantId: selectedVariant.id,
      quantity: quantity || 1,
    })
  }

  return (
    <BuyButtonWrapper>
      <Button
        disabled={
          loading ||
          Boolean(!selectedVariant) ||
          !selectedVariant?.availableForSale
        }
        onClick={handleClick}
        textAlign="center"
      >
        {selectedVariant && !selectedVariant?.availableForSale
          ? 'Out of Stock'
          : buttonLabel}
      </Button>
    </BuyButtonWrapper>
  )
}
